export default __webpack_public_path__ + "static/client-5-fbfba63c7cfeaed11afa0ad9724e5f31.jpg";